export function getCheckoutLink(checkout_token) {
  return `${process.env.SITE_PATH}/checkout/${checkout_token}`;
}
